import React from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import ServiceCard from '../components/ServiceCard';

const Services = () => {
    // Services data based on the PDF content with relevant online images
    const services = [
        {
            id: 'electrical-plumbing',
            title: 'Electrical & Plumbing',
            description: 'Comprehensive electrical and plumbing solutions ensuring seamless installation, maintenance, and repair services with strict safety guidelines.',
            image: 'https://images.unsplash.com/photo-1621905252507-b35492cc74b4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
            icon: 'fa-bolt',
            features: ['Installation & Maintenance', 'Safety Compliance', '24/7 Emergency Service']
        },
        {
            id: 'hvac',
            title: 'HVAC Systems',
            description: 'Installation and maintenance of air conditioning systems, ductwork, ventilation units, chiller systems, VRF systems, and split AC units.',
            image: 'https://plus.unsplash.com/premium_photo-1682126009570-3fe2399162f7?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8YWlyY29ufGVufDB8fDB8fHww',
            icon: 'fa-wind',
            features: ['Air Quality Control', 'Energy Efficiency', 'Chiller & VRF Systems']
        },
        {
            id: 'waterproofing',
            title: 'Waterproofing Solutions',
            description: 'Specialized in roof waterproofing, existing waterproofing removals, priming, and multi-layer applications for structural longevity.',
            image: 'https://media.istockphoto.com/id/1042389232/photo/worker-preparing-part-of-bitumen-roofing-felt-roll-for-melting-by-gas-heater-torch-flame-on.jpg?s=612x612&w=0&k=20&c=rPABKM4VJqZVVTpuITFLNSlXaja4vmwUo3WpD_XgLU0=',
            icon: 'fa-umbrella',
            features: ['Roof Waterproofing', 'Multi-layer Applications', 'Leak Prevention']
        },
        {
            id: 'civil-construction',
            title: 'Civil Construction',
            description: 'Structural repairs, concrete restoration, and general civil construction services ensuring safety and stability of buildings.',
            image: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
            icon: 'fa-building',
            features: ['Structural Repairs', 'Concrete Restoration', 'Compliance with Standards']
        },
        {
            id: 'painting',
            title: 'Painting Work',
            description: 'Interior and exterior painting for homes, commercial buildings with surface preparation, color selection, and various finishing techniques.',
            image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
            icon: 'fa-paint-roller',
            features: ['Interior & Exterior', 'Surface Preparation', 'Various Finishes']
        },
        {
            id: 'aluminum-works',
            title: 'Metal & Aluminum Works',
            description: 'Fabrication, installation of metal and aluminum structures including doors, windows, frames, railings, and cladding.',
            image: 'https://superiorsteelfab.com/wp-content/uploads/2018/07/What%E2%80%99s-the-Difference-Between-Sheet-Metal-Fabrication-and-Ironwork.jpg',
            icon: 'fa-cube',
            features: ['Custom Fabrication', 'Doors & Windows', 'Architectural Structures']
        },
        {
            id: 'block-plastering',
            title: 'Block Fixing & Plastering',
            description: 'Installation of concrete blocks, AAC blocks and plastering with cement, gypsum, or lime plaster for walls and ceilings.',
            image: 'https://media.istockphoto.com/id/843297620/photo/hand-image-worker-concrete-plaster.jpg?s=612x612&w=0&k=20&c=5rNR-hDWuRgzjauaXsC7qbE3PgEYZznE6eLAw58Esuk=',
            icon: 'fa-layer-group',
            features: ['Block Installation', 'Cement Plastering', 'Gypsum Plastering']
        },
        {
            id: 'false-ceiling',
            title: 'False Ceiling Installation',
            description: 'Design and installation of decorative ceilings including gypsum board, POP moldings, acoustic panels, and recessed lighting.',
            image: 'https://images.unsplash.com/photo-1482731215275-a1f151646268?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8ZmFsc2UlMjBjZWlsaW5nfGVufDB8fDB8fHww',
            icon: 'fa-border-style',
            features: ['Gypsum Board Ceilings', 'POP Moldings', 'Acoustic Panels']
        },
        {
            id: 'air-filtration',
            title: 'Air Conditioning & Ventilation',
            description: 'Inspection, maintenance, and repair of AC systems including split units, central AC, HVAC systems, and ductwork.',
            image: 'https://plus.unsplash.com/premium_photo-1683134512538-7b390d0adc9e?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8YWMlMjB1bml0fGVufDB8fDB8fHww',
            icon: 'fa-fan',
            features: ['AC Maintenance', 'Ductwork Repair', 'Energy Savings']
        },
        {
            id: 'iron-mongering',
            title: 'Iron Mongering',
            description: 'Supply, installation of iron-based products including gates, railings, grills, locks, hinges, and custom wrought iron structures.',
            image: 'https://img.freepik.com/free-photo/working-hard-building-man-construction-worker_1122-1849.jpg?semt=ais_hybrid&w=740&q=80',
            icon: 'fa-grip-lines',
            features: ['Wrought Iron Structures', 'Security Solutions', 'Custom Fabrication']
        },
        {
            id: 'wall-partition',
            title: 'Wall Partition Work',
            description: 'Constructing partitions using gypsum board, glass, aluminum, or wood for soundproof, fire-resistant, and decorative designs.',
            image: 'https://images.unsplash.com/photo-1497366412874-3415097a27e7?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8cGFydGl0aW9ufGVufDB8fDB8fHww',
            icon: 'fa-columns',
            features: ['Soundproof Partitions', 'Fire-resistant Walls', 'Decorative Designs']
        },
        {
            id: 'carpentry',
            title: 'Carpentry & Wood Flooring',
            description: 'Fabrication and installation of wooden structures, furniture, and laying hardwood, laminate, or engineered wood floors.',
            image: 'https://plus.unsplash.com/premium_photo-1683129627035-e5a145c3d705?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8Zmxvb3JpbmclMjBpbnN0YWxsYXRpb258ZW58MHx8MHx8fDA%3D',
            icon: 'fa-tree',
            features: ['Custom Furniture', 'Hardwood Flooring', 'Cabinet Installation']
        },
        {
            id: 'tiling',
            title: 'Floor & Wall Tiling',
            description: 'Installation of ceramic, porcelain, marble, granite, or mosaic tiles for durable, water-resistant, and aesthetically pleasing surfaces.',
            image: 'https://plus.unsplash.com/premium_photo-1683121304531-8d12ffd0c8f5?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8dGlsaW5nfGVufDB8fDB8fHww',
            icon: 'fa-border-all',
            features: ['Ceramic & Porcelain', 'Marble & Granite', 'Water-resistant Installation']
        },
        {
            id: 'fire-protection',
            title: 'Fire Protection Systems',
            description: 'Installation and maintenance of fire protection systems as part of our comprehensive electromechanical services.',
            image: 'https://images.unsplash.com/photo-1577678923709-758495cb4497?fm=jpg&q=60&w=3000&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8ZmlyZSUyMHNwcmlua2xlcnxlbnwwfHwwfHx8MA%3D%3D',
            icon: 'fa-fire-extinguisher',
            features: ['System Installation', 'Regular Maintenance', 'Safety Compliance']
        },
        {
            id: 'maintenance',
            title: 'Maintenance Services',
            description: 'Regular maintenance and troubleshooting of all installed systems ensuring smooth operation and longevity.',
            image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
            icon: 'fa-tools',
            features: ['Preventive Maintenance', '24/7 Support', 'System Optimization']
        }
    ];

    return (
        <>
            <Helmet>
                <title>Our Services | LAMSAT Engineering Solutions</title>
                <meta
                    name="description"
                    content="Complete range of engineering services including HVAC, Electrical, Plumbing, Waterproofing, Civil Construction, and more in Dubai, UAE."
                />
                <meta
                    name="keywords"
                    content="LAMSAT, engineering services Dubai, HVAC, electrical, plumbing, waterproofing, civil construction, maintenance UAE"
                />
            </Helmet>

            {/* Hero Section */}
            <section className="contact-hero">
                <div className="container">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        className="contact-hero-content"
                    >
                        <h1 className="display-5 fw-bold mb-3">Our Professional Services</h1>
                        <p className="lead mb-0">
                            Your ultimate one-stop engineering service provider in Dubai, UAE
                        </p>
                        <div className="mt-3">
                            <small className="text-light">
                                TRN: 104929219400003 | Trade License No. 880897 | Registration No. 2552101
                            </small>
                        </div>
                    </motion.div>
                </div>
            </section>

            {/* Company Introduction */}
            <section className="py-5 bg-off-white">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-8 mx-auto">
                            <motion.div
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5 }}
                                viewport={{ once: true }}
                                className="text-center"
                            >
                                <h2 className="section-title section-title-center">About LAMSAT</h2>
                                <p className="lead text-muted mb-4">
                                    Lamsat Omar And Mohammed Technical Services LLC is a leading provider of electrical,
                                    plumbing, waterproofing, and civil construction services, specializing in large-scale
                                    projects such as high-rise buildings, commercial complexes, and industrial infrastructure.
                                </p>
                                <p className="text-muted">
                                    With extensive experience in handling 72-building-scale projects, we are committed to
                                    delivering high-quality solutions that ensure durability, safety and efficiency.
                                </p>
                            </motion.div>
                        </div>
                    </div>
                </div>
            </section>

            {/* All Services Grid */}
            <section className="py-5">
                <div className="container">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        viewport={{ once: true }}
                        className="text-center mb-5"
                    >
                        <h2 className="section-title section-title-center">Our Comprehensive Services</h2>
                        <p className="text-muted px-3 px-md-0">
                            Professional engineering solutions for residential, commercial, and industrial projects
                        </p>
                    </motion.div>

                    <div className="row g-4">
                        {services.map((service, index) => (
                            <div
                                key={service.id}
                                className="col-12 col-sm-6 col-lg-4"
                            >
                                <ServiceCard service={service} index={index} />
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Why Choose Us Section */}
            <section className="py-5 bg-off-white">
                <div className="container">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        viewport={{ once: true }}
                        className="text-center mb-5"
                    >
                        <h2 className="section-title section-title-center">Why Choose LAMSAT?</h2>
                        <p className="text-muted px-3 px-md-0">
                            We stand out with our commitment to excellence and customer satisfaction
                        </p>
                    </motion.div>

                    <div className="row g-4">
                        {[
                            {
                                icon: 'fa-chart-line',
                                title: 'Proven Track Record',
                                desc: 'Successful completion of 72+ large-scale projects including high-rise buildings and commercial complexes'
                            },
                            {
                                icon: 'fa-users',
                                title: 'Expert Team',
                                desc: 'Skilled professionals with 20-30 years of industry experience in UAE construction sector'
                            },
                            {
                                icon: 'fa-award',
                                title: 'High-Quality Materials',
                                desc: 'Use of premium materials and equipment for lasting, durable results'
                            },
                            {
                                icon: 'fa-shield-alt',
                                title: 'Compliance & Safety',
                                desc: 'Strict adherence to UAE regulations, industry standards and safety protocols'
                            },
                            {
                                icon: 'fa-clock',
                                title: 'Timely Execution',
                                desc: 'Efficient project management ensuring on-time completion of all projects'
                            },
                            {
                                icon: 'fa-handshake',
                                title: 'Customer Satisfaction',
                                desc: 'Building long-term relationships through reliable service and transparent communication'
                            },
                        ].map((feature, index) => (
                            <motion.div
                                key={index}
                                className="col-12 col-sm-6 col-lg-4"
                                initial={{ opacity: 0, y: 30 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                viewport={{ once: true }}
                            >
                                <div className="bg-white rounded-lg shadow-sm p-4 h-100 d-flex flex-column">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="feature-icon-square me-3 flex-shrink-0">
                                            <i className={`fas ${feature.icon} text-primary-blue fs-5`}></i>
                                        </div>
                                        <h5 className="mb-0 fs-6 fs-md-5">{feature.title}</h5>
                                    </div>
                                    <p className="text-muted mb-0 flex-grow-1 small small-md">{feature.desc}</p>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Call to Action */}
            <section className="contact-cta">
                <div className="container">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        viewport={{ once: true }}
                        className="cta-content"
                    >
                        <h2>Ready to Start Your Project?</h2>
                        <p>
                            Contact us today for a free consultation and professional engineering solutions
                        </p>
                        <div className="cta-buttons">
                            <a href="tel:+971568583383" className="cta-button primary text-decoration-none">
                                <i className="fas fa-phone me-2"></i> Call Us Now
                            </a>
                            <a href="/contact" className="cta-button secondary text-decoration-none">
                                <i className="fas fa-envelope me-2"></i> Get Free Quote
                            </a>
                        </div>
                        <div className="mt-4">
                            <p className="mb-1">
                                <i className="fas fa-map-marker-alt me-2"></i>
                                Office No.33, Second Floor, Building Smark 2, Ras Al Khor, Dubai, UAE
                            </p>
                            <p className="mb-0">
                                <i className="fas fa-envelope me-2"></i>
                                sales@lamsatalbedaya.com
                            </p>
                        </div>
                    </motion.div>
                </div>
            </section>
        </>
    );
};

export default Services;